// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animated-section {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.animated-section.animate-in {
  opacity: 1;
  transform: translateY(0);
}

/* Farklı animasyon varyasyonları için utility sınıfları */
.fade-in-up {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease-out;
}

.fade-in-up.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.fade-in-left {
  opacity: 0;
  transform: translateX(-30px);
  transition: all 0.6s ease-out;
}

.fade-in-left.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.fade-in-right {
  opacity: 0;
  transform: translateX(30px);
  transition: all 0.6s ease-out;
}

.fade-in-right.animate-in {
  opacity: 1;
  transform: translateX(0);
}

.scale-in {
  opacity: 0;
  transform: scale(0.9);
  transition: all 0.6s ease-out;
}

.scale-in.animate-in {
  opacity: 1;
  transform: scale(1);
}

/* Stagger animasyonları için */
.stagger-1 {
  animation-delay: 0.1s;
}
.stagger-2 {
  animation-delay: 0.2s;
}
.stagger-3 {
  animation-delay: 0.3s;
}
.stagger-4 {
  animation-delay: 0.4s;
}
.stagger-5 {
  animation-delay: 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/components/AnimatedSection/AnimatedSection.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,2BAA2B;EAC3B,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,0DAA0D;AAC1D;EACE,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB","sourcesContent":[".animated-section {\n  opacity: 0;\n  transform: translateY(50px);\n  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.animated-section.animate-in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Farklı animasyon varyasyonları için utility sınıfları */\n.fade-in-up {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: all 0.6s ease-out;\n}\n\n.fade-in-up.animate-in {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.fade-in-left {\n  opacity: 0;\n  transform: translateX(-30px);\n  transition: all 0.6s ease-out;\n}\n\n.fade-in-left.animate-in {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.fade-in-right {\n  opacity: 0;\n  transform: translateX(30px);\n  transition: all 0.6s ease-out;\n}\n\n.fade-in-right.animate-in {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.scale-in {\n  opacity: 0;\n  transform: scale(0.9);\n  transition: all 0.6s ease-out;\n}\n\n.scale-in.animate-in {\n  opacity: 1;\n  transform: scale(1);\n}\n\n/* Stagger animasyonları için */\n.stagger-1 {\n  animation-delay: 0.1s;\n}\n.stagger-2 {\n  animation-delay: 0.2s;\n}\n.stagger-3 {\n  animation-delay: 0.3s;\n}\n.stagger-4 {\n  animation-delay: 0.4s;\n}\n.stagger-5 {\n  animation-delay: 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
